// Shared layout for all static legal/info pages — keeps look consistent.
import React, { useEffect } from 'react';

const COMPANY = {
  name: 'Elite Travo Pvt. Ltd.',
  shortName: 'Elite Travo',
  email: 'support@elitetravo.com',
  phone: '+91 80-4567-8910',
  address: 'Level 7, Prestige Tech Park, Outer Ring Road, Bengaluru 560103, India',
  gstin: '29ABCDE1234F2Z5',
  cin: 'U63040KA2025PTC123456',
};

const LegalLayout = ({ title, eyebrow = 'Legal', lastUpdated, children }) => {
  // Lightweight per-page <title> + meta description — no react-helmet dependency.
  useEffect(() => {
    const prev = document.title;
    document.title = `${title} · Elite Travo`;
    const desc = document.querySelector('meta[name="description"]');
    const prevDesc = desc?.getAttribute('content');
    desc?.setAttribute('content', `${title} — Elite Travo's official ${title.toLowerCase()} page.`);
    return () => {
      document.title = prev;
      if (prevDesc) desc?.setAttribute('content', prevDesc);
    };
  }, [title]);

  return (
    <div className="bg-white dark:bg-gray-950 min-h-screen">
      <div className="bg-gradient-to-br from-red-600 to-red-800 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
          <p className="uppercase tracking-widest text-[11px] text-white/80 font-semibold mb-2">{eyebrow}</p>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold">{title}</h1>
          {lastUpdated && (
            <p className="text-sm text-white/85 mt-3">Last updated: {lastUpdated}</p>
          )}
        </div>
      </div>
      <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 prose prose-slate dark:prose-invert prose-headings:font-bold prose-h2:text-xl prose-h2:mt-8 prose-h2:mb-2 prose-p:text-[15px] prose-li:text-[15px] max-w-none">
        {children}
      </article>
    </div>
  );
};

export { COMPANY };
export default LegalLayout;
